//=====================================
//jquery
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
//=====================================
window.$ = window.jQuery = require('jquery');
global.$ = global.jQuery = require('jquery');
window.Popper = require('@popperjs/core');

//=====================================
//Bootstrap
//import * as bootstrap from 'bootstrap';
// // Or import only needed plugins
// import { Tooltip as Tooltip, Toast as Toast, Popover as Popover } from 'bootstrap';
// // Or import just one
// import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
//=====================================
require('bootstrap');

//=====================================
//Gsap
//=====================================
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import { Draggable } from "gsap/dist/Draggable"; // Draggableを追加
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Draggable);

//=====================================
//SplitType
//=====================================
const SplitType = require('split-type').default;
window.SplitType = SplitType;

//=====================================
//Swiper
// import Swiper JS
// Swiper, Keyboard, Navigation, Pagination, Controller, History, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Lazy, A11y
//=====================================
// const Swiper = require('swiper/bundle').default;
// const { Navigation, Pagination, Autoplay, EffectFade } = Swiper;
// Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
// window.Swiper = Swiper;
// //////////////////////


$(function(){
//////////////////////
//SP BUGER MENU
//////////////////////
$('#global_burgermenu > button').on('click', function() {
  $(this).toggleClass('active');
  if($(this).hasClass('active')){
      $('body').addClass('is-sp-menu');
      $('body').removeClass('rm-sp-menu');
  }else{
      $('body').removeClass('is-sp-menu');
      $('body').addClass('rm-sp-menu');
  }
  return false;
});

$("#global-sp-menu").on("click",function(){
  $('#global_burgermenu > button').trigger('click');
})

$(document).on('click', function(event) {
  if ($('body').hasClass('is-sp-menu') && !$(event.target).closest("#global-sp-menu").length) {
    $('#global_burgermenu > button').trigger('click');
  }
});



//////////////////////
//SCROLL ANIMTAION
//////////////////////
 // URLのハッシュが存在するかチェック
 if (window.location.hash) {
  var targetId = window.location.hash.substring(1);
  var targetElement = $('#' + targetId);

  if (targetElement.length > 0) {
    targetElement.click();
    setTimeout(function() {
      var targetOffset = targetElement.offset().top;
      var bodyOffset = $('body').scrollTop();
      var scrollTo = targetOffset - bodyOffset;
      $('html, body').animate({
        scrollTop: scrollTo
      }, 1000);  // スクロール時間（ミリ秒）
    }, 100);  // 適宜調整した遅延時間
  }
}

 // URLのハッシュを削除
$(window).on('scroll', function() {
  clearTimeout(window.scrollTimeout);
  window.scrollTimeout = setTimeout(function() {
    if (window.location.hash !== '') {
      history.replaceState(null, null, ' '); // ハッシュを削除
    }
  }, 150);  // スクロール停止後150ミリ秒後に実行
});


var headerH = $("#header").outerHeight(true);//headerの高さを取得    
function FixedAnime() {
  var scroll = $(window).scrollTop();
  if (scroll >= headerH){//headerの高さを超えたら
        $('body').addClass('is_scroll');
  }else{
        $('body').removeClass('is_scroll');
  }    
}
// 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function () {
    FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
  });

  // ページが読み込まれたらすぐに動かしたい場合の記述
  $(window).on('load', function () {
    FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
  });
});//$function()




/* =============================================================================
SCROLL HEADER HEIGHT
============================================================================= */
$(function(){

const mvimgs = $(".gsap-box-a");
mvimgs.each(function() {
  const mvimg = $(this);
  const chars = mvimg.find(".tit-m .char, .tit-s");
  const titTopChars = mvimg.find(".tit-top .char");

  gsap.from(titTopChars, {
    y: -500,
    opacity: 0,
    ease: "bounce.out",
    duration: 1.8,
    stagger: 0.05,
    scrollTrigger: {
      trigger: mvimg,
      start: 'top bottom',
      end: 'bottom bottom',
    },
    onComplete: function() {
      gsap.to(titTopChars, {
        y: 0,
        opacity: 1,
        ease: "bounce.out",
        duration: 1
      });
    }
  });

  gsap.from(chars, {
    x: function() { return gsap.utils.random(-1500, 1500); },
    y: function() { return gsap.utils.random(-1500, 1500); },
    scale: function() { return gsap.utils.random(.1, 20); },
    opacity: 0,
    rotation: function() { return gsap.utils.random(-360, 360); },
    stagger: {
      amount: 1,
      from: "center"
    },
    scrollTrigger: {
      trigger: mvimg,
      start: 'top bottom',
      end: 'bottom bottom',
      toggleActions: "play none none reverse"
    },
    onComplete: function() {
    }
  });
});


///////////////////////////////////////////////////////////////////
// SCROLL NEXT
///////////////////////////////////////////////////////////////////

$('.trigger-yes').on('click', function(e) {
  e.preventDefault();
  const $this = $(this);
  const href = $this.attr('href');
  const $parent = $(this).closest(".gsap-box-a");
  const targetSelector = $parent.find('.char');
  const params = {
    x: function() { return gsap.utils.random(-1000, 1000); },
    y: function() { return gsap.utils.random(-1000, 1000); },
    scale: function() { return gsap.utils.random(0.1, 3); },
    opacity: 0,
    duration: .3,
    rotation: function() { return gsap.utils.random(-720, 720); },
    stagger: {
      amount: .5,
      from: "center"
    },
    onComplete: function() {
      // アニメーションが完了したらページ遷移
      window.location.href = href;

      // .trigger-yes ボタンをクリックしたときと同様のアクションを実行して要素を元の状態に戻す
      const chars = $parent.find('.char');
      gsap.timeline()
        .to(chars, {
          x: 0,
          y: 0,
          scale: 1,
          opacity: 1,
          rotation: 0,
          stagger: {
            amount: 0.3,
            from: 'center'
          },
          duration: 1
        });
    }
  };
  gsap.to(targetSelector, params);
});


// NO ボタンをクリックしたときのアニメーションを設定する
$('.trigger-no').on('click', function() {
  const chars = $(this).closest('.gsap-box-a').find('.char');
  gsap.timeline()
    .to(chars, {
      x: 0,
      y: 0,
      scale: 1,
      opacity: 1,
      rotation: 0,
      stagger: {
        amount: 0.3,
        from: 'center'
      },
      duration: 1,
      onComplete: function() {
        // アニメーション完了後に実行する処理
      }
    });
});

//////////////////
///横スクロール　パララックス
//////////////////
let scrollContainers = $(".horizontal-slide-gsap");
  scrollContainers.each(function() {
    let scrollContainer = $(this);
    let sections = scrollContainer.find(".item-slide");
    let images = scrollContainer.find(".js-img");
    let heading = scrollContainer.find(".heading-wrap h2");

    let scrollTween = gsap.to(sections, {
      xPercent: -100 * (sections.length - 1),
      ease: "none"
    });

    let horizontalScroll = ScrollTrigger.create({
      animation: scrollTween,
      trigger: scrollContainer,
      pin: true,
      scrub: 1,
      end: () => "+=" + scrollContainer.outerWidth(),
    });

    function txtSplit(el) {
      var content = el.text();
      var text = content.trim();
      var newHtml = "";

      text.split("").forEach(function (v) {
        newHtml += "<span>" + v + "</span>";
      });
      el.html(newHtml);
    }

    images.each(function(i, img) {
      gsap.to(img, {
        scrollTrigger: {
          trigger: img,
          start: "top center",
          end: "bottom center",
          horizontal: true,
          scrub: 0.2,
          containerAnimation: scrollTween,
        },
        x: -150,
        ease: "none",
      });
    });

    heading.each(function(i, h) {
      txtSplit($(h));
      gsap.from($(h).find("span"), {
        scrollTrigger: {
          trigger: h,
          start: i === 0 ? "top 10%" : "10% center",
          horizontal: true,
          containerAnimation: scrollTween,
          toggleActions: "play none none reverse",
        },
        stagger: {
          each: 0.02,
        },
        y: i === 0 ? "30%" : "50%",
        autoAlpha: 0,
        duration: 0.4,
      });
    });
  });

///////////////////////////
// function positionElements(radius, elementCount) {
//   var angle = (2 * Math.PI) / elementCount;
//   var positions = [];
//   for (var i = 0; i < elementCount; i++) {
//     var x = radius * Math.cos(i * angle);
//     var y = radius * Math.sin(i * angle);
//     positions.push({ x: x, y: y });
//   }
//   return positions;
// }


  // var elements = $('.icn-tags');
  // var radius = 50;
  // var positions = positionElements(radius, elements.length);

  // gsap.set('.trimspace', { perspective: 400 });

  // elements.each(function(index, element) {
  //   gsap.set(element, {
  //     x: positions[index].x * 23,
  //     y: positions[index].y * 23,
  //     rotation: -1180 + index * (20 / (elements.length - 1)),
  //     transformOrigin: 'bottom center',
  //   });

  //   gsap.to(element, {
  //     duration: 1.4,
  //     scale: 1,
  //     opacity: 1,
  //     ease: 'power2.out',
  //     x: gsap.utils.random(0, 0),
  //     y: gsap.utils.random(0, 0),
  //     rotation: gsap.utils.random(0, 0),
  //     stagger: 0.15,
  //   });
  // });

  const tags = $('.icn-tags');
  tags.each(function(index, tag) {
    gsap.set(tag, {transformOrigin: "50% 50%"});
    $(tag).mouseenter(function() {
      gsap.to(tag, {duration: 0.5, scale: 2, rotation: gsap.utils.random(-20, 20)});
    });
    $(tag).mouseleave(function() {
      gsap.to(tag, {duration: 0.5, scale: 1, rotation: 0});
    });
  });



  const mvImgElements = $('.mvimg');
  mvImgElements.each(function(index, mvImgElement) {
    const boxElement = $(mvImgElement).find('.box');
    const boxElement2 = $(mvImgElement).find('article');
    gsap.to(boxElement, {
      y: 300,
      scale: 1.2,
      rotation: -12,
      scrollTrigger: {
        trigger: mvImgElement,
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }
    });

    gsap.to(boxElement2, {
      x: 50,
      y: 300,
      scale: 1.8,
      rotation: -12,
      scrollTrigger: {
        trigger: mvImgElement,
        start: 'top+=180px top',
        end: 'bottom top',
        scrub: true
      }
    });
  });


/////////////////////////////////////

//////////////////////////////////
  /*右から移動*/
  $('.am-x-r').each(function(index, elm) {
    gsap.from(elm, {
      x: 300,
      autoAlpha: 0,
      opacity: 0,
      duration: 0.5, 
      ease: "power2.out",
      scrollTrigger: {
        trigger: elm,
        start: 'top-=100px bottom', // 開始位置を早めに
        end: 'bottom-=800px top',   // 最終位置を早めに停止
        scrub: 1
      }
    });
  });

  // 左から移動
  $('.am-x-l').each(function(index, elm) {
    gsap.from(elm, {
      x: -300,
      autoAlpha: 0,
      opacity: 0,
      duration: 0.1, 
      ease: "power2.out",
      stagger: 1.02,
      scrollTrigger: {
        trigger: elm,
     start: 'top-=200px bottom', // 開始位置を早めに
      end: 'bottom-=800px top',   // 最終位置を早めに停止
        scrub:1
      }
    });
  });

  // 上から移動
  $('.am-y-t').each(function(index, elm) {
    gsap.from(elm, {
      y: -100,
      autoAlpha: 0,
      duration: 1.5,
      opacity: 1,
      ease: "power2.out",
      stagger: {
        from: "start",
        amount: 0.8
      },
      scrollTrigger: {
        trigger: elm,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1
      }
    });
  });

  // 下から移動
  $('.am-y-b').each(function(index, elm) {
    gsap.from(elm, {
      y: 100,
      autoAlpha: 0,
      duration: 1.5,
      opacity: 1,
      ease: "power2.out",
      stagger: {
        each: 0.5,
        ease: "power4.out",
        from: "start",
        amount: 3.8
      },
      scrollTrigger: {
        trigger: elm,
        start: 'top bottom',
        end: 'bottom bottom',
        scrub: 1
      }
    });
  });

  // 中央からスケール
  $('.am-s-0').each(function(index, elm) {
    gsap.from(elm, {
      scaleX: 0.5,
      duration: 1.5,
      opacity: 0,
      ease: "power2.out",
      scrollTrigger: {
        trigger: elm,
        start: 'top bottom',
        end: 'bottom bottom',
        scrub: 1
      }
    });
  });

  // 画像パララックス
  $('.am-y-plx').each(function(index, elm) {
    gsap.to(elm, {
      y: -100,
      ease: "none",
      scrollTrigger: {
        trigger: elm,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1
      }
    });
  });

  // TOP PAGE MV
  gsap.from("#an-tit", {
    y: -100,
    opacity: 0,
    delay: 1.5,
    duration: 1,
    ease: "power2.out"
  });

  gsap.from("#an-stit", {
    x: -1000,
    y: -1000,
    rotation: -240,
    opacity: 0,
    delay: 2,
    duration: 1,
    scale: 10,
    ease: "power2.out"
  });

  gsap.from("#char2 .char", {
    y: -500,
    x: -500,
    scale: 0,
    rotation: 180,
    stagger: .05,
    opacity: 0,
    delay: 2.2,
    duration: 0.6,
    ease: "power2.out"
  });
  // gsap.utils.toArray('#zzz2 .zzz').forEach( (zzz, index) => {
  //     gsap.fromTo(zzz,1,
  //       {x:-2000,
  //         rotation: 120,
  //         scale: 100,
  //         autoAlpha: 0 },
  //       {x:0,
  //         rotation: 0,
  //         scale:1,
  //         autoAlpha: 1,
  //         duration:1,
  //         scrollTrigger: {
  //         trigger: '#zzz2', //scrub: 1 // markers: true
  //         start: 'top bottom', 
  //         end: 'bottom bottom',
  //         //   scrub: 3,
  //         },
  //       }
  //     );
  // });

});


// window.addEventListener('contextmenu', function (e) {
//   e.preventDefault();
// });



















